import { updateRenewVisaDocumentNoteApi } from "@/api/services/main/renew-visa";
import { Textarea } from "@/components/elements/Textarea";
import { API_SUCCESS_MESSAGE } from "@/constants/common";
import { QUERY_KEYS } from "@/constants/queryKeys";
import { showError } from "@/utils/error";
import { toast } from "@/utils/toast";
import { useQueryClient } from "@tanstack/react-query";
import { FC, useState } from "react";

export type TRenewVisaNoteTextAreaProps = {
  renewVisaDocumentId: number;
  defaultNote: string;
  minRows?: number;
};

export const RenewVisaNoteTextArea: FC<TRenewVisaNoteTextAreaProps> = ({ renewVisaDocumentId, defaultNote, minRows }) => {
  const [textareaValue, setTextAreaValue] = useState(defaultNote);

  const queryClient = useQueryClient();

  const onSubmitRenewVisaDocumentNote = async () => {
    if (!renewVisaDocumentId || textareaValue === defaultNote) return;
    try {
      const rs = await updateRenewVisaDocumentNoteApi(renewVisaDocumentId, { note: textareaValue });
      toast.success(rs.message ?? API_SUCCESS_MESSAGE);
      await queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.RENEW_VISA_DOCUMENTS.FETCH_LIST] });
      await queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.RENEW_VISA_DOCUMENTS.FETCH_DETAIL] });
    } catch (error) {
      showError(error);
    }
  };

  return (
    <Textarea
      minRows={minRows}
      value={textareaValue}
      onChange={(e) => setTextAreaValue(e.target.value)}
      onBlur={() => onSubmitRenewVisaDocumentNote()}
    />
  );
};
